<div class="row justify-content-center mt-4">
        <div class="col-md-8">
            <div class="d-flex justify-content-center">
            <fa-icon icon="bug" class="fa-5x primary"></fa-icon>
            </div>
            <div class="d-flex justify-content-center">
            <h2 class="align-text-center"> ERROR.PAGE_NOT_FOUND </h2>
            </div>
        </div>
    </div>